import styled from 'styled-components'
import { device } from '../../../../styles/GlobalVariables'

const Svg = styled.svg`
  width: 30px;
  height: 30px;

  ${device.regular} {
    width: 34.138px;
    height: 34.138px;
  }
`

export const PlayIcon = () => (
  <Svg
    viewBox='0 0 34.1379 34.1379'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M27.9682 16.1609C29.0519 16.7133 29.0519 18.0941 27.9682 18.6465L8.46077 28.5886C7.37702 29.1409 6.02234 28.4505 6.02234 27.3458L6.02234 7.46155C6.02234 6.35686 7.37702 5.66644 8.46077 6.21878L27.9682 16.1609Z'
      fill='white'
    />
  </Svg>
)
